/* eslint-disable react/no-unescaped-entities */
import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Wrapper, Title, DescriptionContainer, Description } from "./styles";

const defaultIcon = require("Assets/img/empty-estimated-quote.svg");

type CartonSSCCEmptySectionProps = {
  icon?: string;
};

export const CartonSSCCEmptySection: React.FC<CartonSSCCEmptySectionProps> = (props) => {
  const { icon } = props;

  const { t: translate } = useTranslation();

  return (
    <Wrapper
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      data-cy="carton-sscc-maintenance-empty"
    >
      <Grid item xs={12}>
        <img src={icon || defaultIcon} alt="empty state" />
      </Grid>
      <Grid container direction="column" alignItems="center" justifyContent="center" spacing={2}>
        <Grid item xs={4}>
          <Title>{translate("itLooksLikeThereSNoDataYet")}</Title>
        </Grid>
        <DescriptionContainer item xs={4}>
          <Description>{translate("youCanStartByCreatingASscc")}</Description>
        </DescriptionContainer>
      </Grid>
    </Wrapper>
  );
};
